export default {
  install() {
    // Plugin Pinia - préchargement désactivé
    // Les stores chargeront leurs données à la demande
  }
}